"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskState = void 0;
var TaskState = (function () {
    function TaskState() {
    }
    TaskState.prototype.shouldBeDelayed = function (delay) {
        if (!this.lastRun)
            return false;
        return this.lastRun + delay > Date.now();
    };
    TaskState.prototype.updateLastRun = function () {
        this.lastRun = Date.now();
    };
    return TaskState;
}());
exports.TaskState = TaskState;
//# sourceMappingURL=utils.js.map